/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingnotconnected2Inputs */

const en_crosspostingnotconnected2 = /** @type {(inputs: Crosspostingnotconnected2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not connected`)
};

const de_crosspostingnotconnected2 = /** @type {(inputs: Crosspostingnotconnected2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht verbunden`)
};

/**
* | output |
* | --- |
* | "Not connected" |
*
* @param {Crosspostingnotconnected2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingnotconnected2 = /** @type {((inputs?: Crosspostingnotconnected2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingnotconnected2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingnotconnected2(inputs)
	return de_crosspostingnotconnected2(inputs)
});
export { crosspostingnotconnected2 as "crosspostingNotConnected" }